module.exports = __webpack_public_path__ + "static/barbarawork4-44c6ea9dc99f0871f66fcc5cd41bb490.jpg";